<template>
  <!-- win3 -->
  <Index53000 v-if="isWin3" />

  <!-- win1 + win2 -->
  <Index50000 v-else />
</template>

<script setup>
import { templateTypeWin3Flag } from '@/utils/templateType'
import Index50000 from './template/index_50000.vue'
import Index53000 from './template/index_53000.vue'

// const localConfig = JSON.parse(localStorage.getItem('localConfig'))
// const appid = Number(localConfig.appid)
// const templateType = computed(() => {
//   if (appid >= 53000 && appid < 54000) {
//     return 'Index53000'
//   }
//   return 'Index50000'
// })

const isWin3 = ref(false)

onMounted(async () => {
  isWin3.value = await templateTypeWin3Flag()
})
</script>
